module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "primary--text"
  }, [_c('v-icon', {
    attrs: {
      "info": ""
    }
  }, [_vm._v("person_outline")]), _vm._v(" Solicitudes de trámites de la entidad")], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('crud-table', {
    attrs: {
      "headers": _vm.$store.state.user.id_rol === 3 || _vm.$store.state.user.id_rol === 4 ? _vm.headers_pago : _vm.headers_sin_pago,
      "url": _vm.url,
      "filters": _vm.filters,
      "graphql": _vm.graphql,
      "data-graphql": _vm.dataGraphql,
      "widthModal": 800,
      "checkbox": _vm.$store.state.user.id_rol === 7 || _vm.$store.state.user.id_rol === 4,
      "showFilter": true
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(items) {
        return [_c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v("\n            " + _vm._s(items.item.id) + "\n          ")]), _vm._v(" "), _c('td', {
          staticClass: "nowrap"
        }, [(_vm.$store.state.user.id_rol === 3 || _vm.$store.state.user.id_rol === 6) ? _c('v-btn', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openRevisor(items.item)
            }
          }
        }, [_c('v-icon', [_vm._v("edit")]), _vm._v(" Ver detalles\n            ")], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.id_rol === 4 || _vm.$store.state.user.id_rol === 7) ? _c('v-btn', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openFirmante(items.item)
            }
          }
        }, [_c('v-icon', [_vm._v("edit")]), _vm._v(" Ver detalles\n            ")], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [(items.item.documento_derivar === 'CANCILLERIA' && items.item.estado === 'FIRMADO_ENTIDAD') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": _vm.estados[items.item.estado],
            "text-color": "white"
          }
        }, [_c('small', [_vm._v("CREADO - CANCILLERIA")])]) : _c('v-chip', {
          attrs: {
            "label": "",
            "color": _vm.estados[items.item.estado],
            "text-color": "white"
          }
        }, [_c('small', [_vm._v(_vm._s(items.item.estado.replace(/_/gi, ' ')))])])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.tramite_cod_seguimiento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.documento_nombre))]), _vm._v(" "), _c('td', [_c('em', [_c('strong', [_vm._v(_vm._s(items.item.tramite_solicitante_tipo_documento) + ": ")]), _vm._v("\n              " + _vm._s(items.item.tramite_solicitante_nro_documento))]), _c('br'), _vm._v("\n            " + _vm._s(items.item.tramite_solicitante_nombres) + "\n            " + _vm._s(items.item.tramite_solicitante_primer_apellido) + "\n            " + _vm._s(items.item.tramite_solicitante_segundo_apellido) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$datetime.format(items.item._created_at)))]), _vm._v(" "), (_vm.$store.state.user.id_rol === 4 || _vm.$store.state.user.id_rol === 3) ? _c('td', {
          staticClass: "text-xs-center"
        }, [(items.item.pago_entidad || items.item.pago_cancilleria) ? _c('v-icon', {
          attrs: {
            "color": "success"
          }
        }, [_vm._v("check")]) : _c('v-icon', {
          attrs: {
            "color": "error"
          }
        }, [_vm._v("close")])], 1) : _vm._e()]
      }
    }])
  }, [_c('template', {
    slot: "buttons"
  }, [(_vm.$store.state.user.id_rol === 7 || _vm.$store.state.user.id_rol === 4) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.openFirmanteGrupal()
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("check")]), _vm._v(" Firmar\n            ")], 1), _vm._v(" "), _c('span', [_vm._v("Firmar documentos seleccionados")])], 1) : _vm._e()], 1), _vm._v(" "), _c('template', {
    slot: "labels"
  }, [(this.regionales.length > 1) ? _c('div', {
    staticClass: "text-xs-right"
  }, [_c('v-select', {
    attrs: {
      "label": "Regional",
      "items": _vm.regionales
    },
    model: {
      value: (_vm.regional),
      callback: function($$v) {
        _vm.regional = $$v
      },
      expression: "regional"
    }
  })], 1) : _c('div', {
    staticClass: "text-xs-right"
  }, [_c('strong', [_vm._v("REGIONAL:")]), _vm._v(" "), _c('v-chip', {
    attrs: {
      "label": "",
      "color": "info",
      "text-color": "white"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.user.departamento.split(',').join(' - ')) + "\n            ")])], 1)])], 2)], 1)], 1), _vm._v(" "), (_vm.$store.state.user.id_rol === 6 || _vm.$store.state.user.id_rol === 3) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "scrollable": "",
      "max-width": "1200"
    },
    model: {
      value: (_vm.$store.state.modal2),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "modal2", $$v)
      },
      expression: "$store.state.modal2"
    }
  }, [(_vm.solicitud) ? _c('revisor', {
    attrs: {
      "solicitud": _vm.solicitud
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.id_rol === 4 || _vm.$store.state.user.id_rol === 7) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "scrollable": "",
      "max-width": "1200"
    },
    model: {
      value: (_vm.$store.state.modal3),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "modal3", $$v)
      },
      expression: "$store.state.modal3"
    }
  }, [(_vm.solicitudC) ? _c('firmante', {
    attrs: {
      "solicitud": _vm.solicitudC
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.id_rol === 4 || _vm.$store.state.user.id_rol === 7) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "scrollable": "",
      "max-width": "1200"
    },
    model: {
      value: (_vm.$store.state.modal7),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "modal7", $$v)
      },
      expression: "$store.state.modal7"
    }
  }, [(_vm.firmador) ? _c('Firmantegrupal', {
    attrs: {
      "solicitud": _vm.solicitudC,
      "persistent": "",
      "scrollable": ""
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b154448","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/eRegister/tramiteDoc/TramiteDoc.vue
// module id = 524
// module chunks = 2